import { useQuery } from "@tanstack/react-query";
import { get } from "lodash-es";
import type { CatalogSampleType } from "../../models/CatalogSampleType";
import { getCatalogSampleTypes } from "../../repositories/CatalogSampleTypeRepository";

export const useCatalogSampleTypesQuery = () => {
  return useQuery<CatalogSampleType[], Error>({
    queryKey: ["lab-catalog-sample-types"],
    meta: { realtime: ["LAB.GetCatSampleTypes"] },
    queryFn: async ({ signal }) => {
      const resp = await getCatalogSampleTypes(signal);
      if (!resp.ok)
        throw new Error(resp.message ?? "Failed to load catalog sample types");
      return get(resp, "data.tables[0].rows", []);
    },
  });
};
